/**
 * Header: mobile menu toggle
 */
export function initHeader() {
  const toggle = document.getElementById('menu-toggle');
  const nav    = document.getElementById('nav-links');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('nav-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });

  // Close menu on nav link click (mobile)
  nav.querySelectorAll('.nav-link').forEach(link => {
    link.addEventListener('click', () => nav.classList.remove('nav-open'));
  });
}
